window.CustomFieldGroupPrefsListing = {
	
	prepareFilterForm: function(){
        var options = {success:function(data){CustomFieldGroupPrefsListing.processFilterForm(data);}, dataType:"json"};
        MyForm.prepare("customfieldsgroupsFilterForm", "customfields&action=updateCfgListing", options);
		
	},
	
	processFilterForm: function(data){
		Listing.refresh("customfieldsgroupsListing", data, data.customfieldsgroups_metadatas);	
	}
}

window.CustomFieldPrefsListing = {
	
	prepareFilterForm: function(){
        var options = {success:function(data){CustomFieldPrefsListing.processFilterForm(data);}, dataType:"json"};
        MyForm.prepare("customfieldsFilterForm", "customfields&action=updateCfListing", options);
		CustomFieldPrefsListing.initMultiple();
		
	},
	
	processFilterForm: function(data){
		Listing.refresh("customfieldsListing", data, data.customfields_metadatas);	
		CustomFieldPrefsListing.initMultiple();
	},
	
	initMultiple: function(){
		
		$('#customfieldsListing_filter_types').multipleSelect({
			countSelected : false,
			placeholder: Loc.g("Choisissez un type"),
			width: 245,
			selectAll: false,
			selectAllText: Loc.g('Tout Sélectionner'),
			allSelected: Loc.g('Tous sélectionnés'),
            onClick: function(view) {
				Listing.update("customfieldsListing");
            },
			onOptgroupClick: function(view) {
				Listing.update("customfieldsListing"); 
			},	
		 });
		 
		$('#customfieldsListing_filter_props').multipleSelect({
			placeholder: Loc.g("Choisissez une propriété"),
			width: 245,
			selectAll: false,
			selectAllText: Loc.g('Tout Sélectionner'),
			allSelected: Loc.g('Tous sélectionnés'),
            onClick: function(view) {
				Listing.update("customfieldsListing");
            },
			onOptgroupClick: function(view) {
				Listing.update("customfieldsListing"); 
			 },
			 onCheckAll: function(view){
				 Listing.update("customfieldsListing"); 
			 }
		 });
		 
		$('.itemProps').multipleSelect({
			placeholder: Loc.g("Choisissez une propriété"),
			width: 245,
			selectAll: false,
			countSelected : false,
			selectAllText: Loc.g('Tout Sélectionner'),
			allSelected: Loc.g('Tous sélectionnés'),
            onClick: function(view) {
				var opts = {
					action		: 'updateCfProperty',
					cfid		: view.instance.$el.closest('tr').attr('id').split('_')[1],
					property	: view.value,
					checked		: view.checked ? 'Y' : 'N'
				};
				MyFacture.post('customfields', opts);
            }
		 });
		 
	}
	
	
};

window.CustomFieldListingTools = {
	
	initCF : function(listingName) {
		
		/*
		 * scheme:
		 * - [$LISTING_NAME]_filter_customfields_exists_[CFPROP]_[CFTYPE]_[CFID]
		 */
		
		var $scope = $('#' + listingName + '_searchEngineContent'); // scope to search

		// usual inputs
		$scope.find('[id^=' + listingName + '_filter_customfields_][id$=_valueExists]').each(function(i, el) {
			CustomFieldListingTools.__processCFInput(el, listingName);			
		});
		
	},
	
	__processCFInput : function(element, listingName) {
		var $current	= $(element);
		var parts		= $current.attr('id').split('_');
		/*
		 * 0	$listingName
		 * 1	'filter'
		 * 2	'customfields'
		 * 3	$cfProp
		 * 4	$cfType
		 * 5	$cfId
		 * 6	'valueExists'
		 */

		CustomFieldListingTools.updateCFWithExists(element, listingName, parts[5], parts[4], parts[3], false);
	},
	
	updateCFWithExists : function(element, listingName, cfid, cftype, cfprop, documentLoaded) {
		documentLoaded	= ((documentLoaded === undefined) ? true : documentLoaded);
		
		var current = $(element);
		
		var base		= listingName + '_filter_customfields_' + cfprop + '_' + cftype + '_' + cfid;
		var periodBase	= listingName + '_filter_period_' + cfprop + '_' + cftype + '_' + cfid;
		var toModify	= [];
		
		switch(cftype) {
			case 'radio':
			case 'select':
			case 'checkbox':
			case 'simpletext':
			case 'richtext':
			case 'url':
			case 'email':
				toModify.push(base);
				break;

			case 'numeric':
				toModify.push(base + '_start');
				toModify.push(base + '_stop');
				break;

			case 'unit':
				toModify.push(base + '_start');
				toModify.push(base + '_stop');
				toModify.push(base + '_unit');
				break;

			case 'date':				
				toModify.push(periodBase);
				toModify.push(periodBase + '_startDate');
				toModify.push(periodBase + '_endDate');
				break;

			case 'boolean':
				toModify.push(base + '_yes');
				toModify.push(base + '_no');
				break;

			case 'amount':
				toModify.push(base + '_start');
				toModify.push(base + '_stop');
				toModify.push(base + '_currency');
				break;
		}	
		
		for(var i in toModify) {
			var modify		= toModify[i];
			var currentNode = $('#' + modify);
			
			if((!documentLoaded || currentNode.is(':visible')) || currentNode.prop('tagName') === 'SELECT' || cftype === 'date') {
				
				if(currentNode.hasClass('mutlipleSelect')) {
					// is a multipleSelect
					/////////////////////////
					
					// disable
					currentNode.multipleSelect(current.prop('checked') ? 'disable' : 'enable');
					
					// value
					if(current.prop('checked')) {
						currentNode.multipleSelect("setSelects", []);
					}
				} else if(currentNode.prop('tagName') === 'SELECT') {
					// is a selectmenu
					/////////////////////////
					
					if(documentLoaded) {
						// disable
//						currentNode.selectmenu(current.prop('checked') ? 'disable' : 'enable');
						if (current.prop('checked')){
							currentNode.attr('disabled', 'disabled');
						} else {
							currentNode.removeAttr('disabled', 'disabled');
						}
						
						// value
						if(current.prop('checked')) {
//							currentNode.selectmenu('value', '0');
							currentNode.val('0');
						}
					}
				} else if(currentNode.prop('tagName') === 'INPUT' && currentNode.attr('type') === 'checkbox') {
					// is a checkbox
					/////////////////////////
					
					if(documentLoaded) {
						// disable
						currentNode.button(current.prop('checked') ? false : true);
						
						// value
						if(current.prop('checked')) {
							currentNode.removeAttr('checked');
							currentNode.button('refresh');
						}
					}
				} else {
					// is a classic input
					/////////////////////////
					
					// disable
					currentNode.prop( "disabled", current.prop('checked') );
					
					// value
					if(current.prop('checked')) {
						currentNode.removeAttr('value');
					}

					if(currentNode.prop('tagName') === 'INPUT') {
						currentNode.css('background-color', current.prop('checked') ? '#f4f4f4' : '#fff');
					}
				}

				// qtip
				var $qtipScope = currentNode.closest('.filter_underlabel');

				if($qtipScope.attr('data-qtiplock-create') !== 'Y' && current.prop('checked')) {
					CustomFieldListingTools.__generateQTip($qtipScope);
					$qtipScope.attr('data-qtiplock-create', 'Y');
					$qtipScope.attr('data-qtiplock-delete', 'N');
				}
				if($qtipScope.attr('data-qtiplock-delete') !== 'Y' && !current.prop('checked') && ('object' === (typeof $qtipScope.data('qtip')))) {
					$qtipScope.qtip('hide');
					$qtipScope.qtip('destroy');
					$qtipScope.attr('data-qtiplock-create', 'N');
					$qtipScope.attr('data-qtiplock-delete', 'Y');
				}
			}
		}
	},
	__generateQTip : function(element) {
		
		element.qtip({
			style : {
				classes : 'custom-qtip',
				def		: false
			},
			position: {
				viewport: true,
				my : 'top center',
				at : 'bottom center'
			},
			show : {
				event : 'mouseover'
			},
			hide : {
				event: 'mouseout', 
				fixed: true,
				delay: 100
			},
			content:{
				text : Loc.g('Non modifiable car vous avez sélectionné un filtre "non renseigné"')
			}
		});
	},
	
	toggleCf : function(id, contextCf, forceState) {

		var state = ['open', 'close'];

		var cfGroup			= $('#cfgroupe_'+id+'_'+contextCf);
		var cfCaret 		= $('#cffa_'+id+'_'+contextCf);
		var currentState 	= (cfGroup.is(':visible') ? 'open' : 'close');

		var toState = (currentState == 'open' ? 'close' : 'open');

		if(forceState !== undefined && state.indexOf(forceState)){
			toState = forceState;
		}

		cfCaret.toggleClass('reverseRotated', toState == 'open');
		cfCaret.toggleClass('rotated', toState == 'close');

		cfGroup[(toState == 'open' ? 'slideDown' : 'slideUp')]('fast', function(){
			MyFacture.customForm(cfGroup);
		});

	},
	
};

window.CustomFieldBuilder = {
	
	deleteOne: function(id){
		MyWindow.alert(Loc.g('Supprimer le champ ?'), {
			type:'warning',
			 buttons    : [
                 {text : Loc.g("Annuler"), click : function(){$(this).dialog('close');}},
                 {text : Loc.g("Valider"), click : function(){CustomFieldBuilder.confirmDeleteOne(id);}}
            ],
		});
	},
	
	confirmDeleteOne: function(id){
		MyWindow.alert(Loc.g("Si vous supprimez ce champ, il n'apparaitra plus sur aucun des éléments auxquels il était lié. <br /> <br />Merci de confirmer la suppression."), {
			type :'error',
			 buttons    : [
                 {text : Loc.g("Annuler"), click : function(){$(this).dialog('close');}},
                 {text : Loc.g("Confirmer la suppression"), click : function(){CustomFieldBuilder.processDeleteOne(id);}}
            ],
		});
		
	},
	
	processDeleteOne: function(id){
		
		MyFacture.post('customfields', {action:'delete', cfid:id}, function(){
			MyFacture.startWait();
			MyWindow.alert(Loc.g('Champ supprimé'), {type:'confirm'});
			window.location.reload();
		});
		
	},
	
	addOne : function(id){
		
		var options = {
            title: Loc.g("Créer un champ personnalisé"),
            buttons: [
                {
					text: Loc.g("Annuler"),
					click: function(){
						MyWindow.close();
					}
				},
                {
					text: Loc.g("Enregistrer"),
					click: function(){
						$("#cfCreateForm").submit();
					}
				}
            ],
            width: 1200,
			height: 800,
            callback: function(){
                CustomFieldBuilder.prepareCreateForm();
            }
        };
        
        MyWindow.load("customfields", {
			action: "createForm",
			cfid: id === undefined ? 0 : id
		}, options);
		
	},
	
	prepareCreateForm: function(){
		
		var formId = "cfCreateForm";
		var options = {
			success:function(data){
				var formIsOk = MyForm.processJson(data, "cfCreateForm");
				if(formIsOk){
                    Quota.checkQuotas(['custom_fields']);
					MyWindow.close();
					$('#listingname').val() == 'customfieldsListing' ? Listing.update() : Utils.reload();
				}
			},
			dataType:"json"
		};
		
		$('.sortable_list:visible').sortable({
			containment : 'parent'
		});
		
		MyForm.prepare(formId, "customfields&action=recordForm", options, true);
		MyFacture.customForm();
		Qtip.init();
	
		CustomFieldBuilder.bindUncheckRadio($(".cf_typesettings"));
		
	},
	
	
	bindUncheckRadio: function(selector){
		
		selector.on("mousedown", "input:radio", function() {
			$(this).data('wasChecked', this.checked);
		});

		selector.on("click", "input:radio",function() {
			if ($(this).data('wasChecked')){
				this.checked = false;
			}
		});
	},
	
	create_switchType: function(){
		var newType = $('#cf_type').val();
		
		$('#cfCreateForm .cf_settings .cf_typesettings').hide();
		$('#cfCreateForm .cf_settings #cf_'+newType).fadeIn(100, function(){});
		
		$('.sortable_list:visible').sortable({
			containment : 'parent'
		});
		
		if(newType == 'third' || newType == 'item' || newType == 'people' || newType == 'staff'){
			$("#cf_showIn_ecommerce").prop("disabled","disabled");
			$("#cf_showIn_ecommerce").next('label').css('text-decoration','line-through');
		} else{
			$("#cf_showIn_ecommerce").removeAttr("disabled");
			$("#cf_showIn_ecommerce").next('label').css('text-decoration','none');
		}
		
		MyFacture.customForm();
		
	},
	
	addRadioOption: function(){
		
//		var nb = $('#cf_radio .radio_list li').not('.default_radio_list').length;
		
		var nb = parseInt($('#cf_radio .radio_list li:last-child').not('.default_radio_list').find("input[type='text']").attr("id").split("_")[3], 10)+1;
		var defaultRadio = $('#cf_radio .radio_list .default_radio_list').clone();

		defaultRadio.removeClass('default_radio_list');
		
		defaultRadio.find("input[type='text']")
				.attr('name', 'cf_radio[list]['+nb+'][value]')
				.attr('id', "cf_radio_list_"+nb+"_value")
				.attr('placeholder', Loc.g('Valeur'));
		
		defaultRadio.find("input[type='radio']")
				.attr('name', 'cf_radio[defaultValue]' )
				.val(nb);
		
		defaultRadio.appendTo('#cf_radio .radio_list').show();
		
		MyFacture.customForm();
		$('.sortable_list:visible').sortable("refresh");
		$(".sortable_list:visible").animate({ scrollTop: $(".sortable_list:visible")[0].scrollHeight}, 100);		
		
	},
	
	addSelectOption: function(){

		var iterator = 0;
		$('#cf_select .select_list li').each(function(){
			if(!$('[name*="cf_select[list]['+iterator+']"]').length){
				return true;
			}
			iterator++;
		});

		var defaultRadio = $('#cf_select .select_list .default_select_list').clone();

		defaultRadio.removeClass('default_select_list');
		
		defaultRadio.find("input[type='text']")
				.attr('name', 'cf_select[list]['+iterator+'][value]')
				.attr('id', "cf_select_list_"+iterator+"_value")
				.attr('placeholder', Loc.g('Valeur'));
		
		defaultRadio.find("input[type='radio']")
				.attr('name', 'cf_select[defaultValue]')
				.val(iterator);
		
		defaultRadio.appendTo('#cf_select .select_list').show();
		
		MyFacture.customForm();
		$('.sortable_list:visible').sortable("refresh");
		$(".sortable_list:visible").animate({ scrollTop: $(".sortable_list:visible")[0].scrollHeight}, 100);		
		
	},
	
	addCheckboxOption: function(){
		
//		var nb = $('#cf_checkbox .checkbox_list li').not('.default_checkbox_list').length + 1;
		
		var nb = parseInt($('#cf_checkbox .checkbox_list li:last-child').not('.default_checkbox_list').find("input[type='text']").attr("id").split("_")[3], 10)+1;
		var defaultRadio = $('#cf_checkbox .checkbox_list .default_checkbox_list').clone();
		
		defaultRadio.removeClass('default_checkbox_list');
		
		defaultRadio.find("input[type='text']")
				.attr('id', "cf_checkbox_list_"+nb+"_value")
				.attr('name', "cf_checkbox[list]["+nb+"][value]")
				.attr('placeholder', Loc.g('Valeur'));
		
		defaultRadio.find("input[type='checkbox']")
				.attr('id', "cf_checkbox_list_"+nb+"_checked")
				.attr('name', "cf_checkbox[list]["+nb+"][checked]")
				.val('Y');
		
		defaultRadio.appendTo('#cf_checkbox .checkbox_list').show();
		
		$('.sortable_list:visible').sortable("refresh");
		$(".sortable_list:visible").animate({ scrollTop: $(".sortable_list:visible")[0].scrollHeight}, 100);
		
	},
	
	removeListption: function(me){
		me.closest('li').remove();
	},
	
	checkThirdTypeChecked: function(){
		var thirdClient		= $("#cf_third_client").prop("checked") ? "Y" : "N";
		var thirdProspect	= $("#cf_third_prospect").prop("checked") ? "Y" : "N";
		var thirdSupplier	= $("#cf_third_supplier").prop("checked") ? "Y" : "N";
		
		if(thirdClient === 'N' && thirdProspect === 'N' && thirdSupplier === 'N'){
			MyWindow.alert(Loc.g('Vous devez choisir au moins un type.'), {
				type:'error',
				 buttons    : [
					{text : Loc.g("Ok"), click : function(){$(this).dialog('close');}}
				]
			});
		}
	},
	
	checkItemTypeChecked: function(){
		var itemProduct		= $("#cf_item_product").prop("checked") ? "Y" : "N";
		var itemService		= $("#cf_item_service").prop("checked") ? "Y" : "N";
		
		if(itemProduct === 'N' && itemService === 'N'){
			MyWindow.alert(Loc.g('Vous devez choisir au moins un type.'), {
				type:'error',
				 buttons    : [
					{text : Loc.g("Ok"), click : function(){$(this).dialog('close');}}
				]
			});
		}
	}
	
};

window.CustomFieldGroupBuilder = {
	
	deleteOne: function(id){
		MyWindow.alert(Loc.g('Supprimer le groupe ?'), {
			type:'warning',
			 buttons    : [
                 {text : Loc.g("Annuler"), click : function(){$(this).dialog('close');}},
                 {text : Loc.g("Valider"), click : function(){CustomFieldGroupBuilder.processDeleteOne(id);}}
            ],
		});
	},
	
	processDeleteOne: function(id){
		
		MyFacture.post('customfields', {action:'deleteGroup', cfgid:id}, function(){
			MyWindow.alert(Loc.g('Groupe supprimé'), {type:'confirm'});
			Listing.update("customfieldsgroupsListing"); 
		});
		
	},
	
	addOne : function(id){
		
		var id = id === undefined ? 0 : id;
		
		var options = {
            title    : Loc.g("Créer un groupe de champs personnalisé"),
            buttons    : [
                {text : Loc.g("Annuler"), click : function(){MyWindow.close();}},
                {text : Loc.g("Enregistrer"), click : function(){$("#cfgCreateForm").submit();}}
            ],
            width : 500,
			height: 600,
            callback    : function(){
                CustomFieldGroupBuilder.prepareCreateForm();
            }
        };
        
        MyWindow.load("customfields", {action:"createGroupForm", cfgid:id}, options);
		
	},
	
	prepareCreateForm: function(){
		
		var formId = "cfgCreateForm";
		var options = {
			success:function(data){
				var formIsOk = MyForm.processJson(data, "cfgCreateForm");
				if(formIsOk){
					MyWindow.close();
					if ($('#customfieldsgroupsListing').length == 1){
						Listing.update("customfieldsgroupsListing"); 
					} else {
						Utils.reload();
					}
				} else {
					$('#cfg_groupsFields li.oneField:not(\'.noField\')').each(function() {
						if($(this).hasClass('failed')) {
							$(this).removeClass('failed');
						}
					});
					
					if (data.form.msg != ""){
						$('#cfgCreateForm').find('.formAlert').html(data.form.msg).show();
					} else {
						$('#cfgCreateForm').find('.formAlert').hide();
					}
					
					if (data.form.fields.length > 0) {
						for (var id in data.form.fields) {
							var field = data.form.fields[id];
							if (field.fieldId === 'customFields') {
								$('#field_' + field.value).addClass(field.skin);
							}
						}
					}
				}
			},
			dataType:"json"
		};
		
		MyForm.prepare(formId, "customfields&action=recordGroupForm", options, true);
		
		$('#cfg_customFieldsSelector').multipleSelect({
			placeholder: Loc.g("Ajouter des champs"),
			width: 450,
			selectAll: false,
			countSelected : false,
			filter: true,
			 onClick: function(view) {
				CustomFieldGroupBuilder.addFieldtoGroup(view);
			 }
		 });
		 
		// set selected from the form inputs
		var selected = [];
		$.each($('input', '#cfg_groupsFields'), function(i, v){
			   selected.push($(v).val());
		});
		$('#cfg_customFieldsSelector').multipleSelect("setSelects", selected);
		$('#cfg_groupsFields:visible').sortable({containment : 'parent'});
		 
	},
	
	addFieldtoGroup: function(view){
		
		var useOnClient		= $('#cfg_customFieldsSelector').find("option[value='"+view.value+"']").attr('useon_client');
		var useOnSupplier	= $('#cfg_customFieldsSelector').find("option[value='"+view.value+"']").attr('useon_supplier');
		var useOnProspect	= $('#cfg_customFieldsSelector').find("option[value='"+view.value+"']").attr('useon_prospect');
		var useOnItem		= $('#cfg_customFieldsSelector').find("option[value='"+view.value+"']").attr('useon_item');
		var useOnService	= $('#cfg_customFieldsSelector').find("option[value='"+view.value+"']").attr('useon_service');
		
		var list = $('#cfg_groupsFields');
		if (view.checked){
			
			var html = "<li id='field_"+view.value+"' class='oneField'><div class='cf_infocontainer'><input type='hidden' value='"+view.value+"' name='cfg_customFields["+view.value+"][cfid]'/>" + view.label + "<a href='javascript:;' onClick='CustomFieldGroupBuilder.removeFieldFromGroup("+view.value+")'><i class='fa fa-times fa-13'></i></a></div>";
			html += "<div class='cf_infocontainer'>";
			if (useOnClient === 'Y'){
				html +=" <span class='cf_tag'>"+Loc.g('Clients')+"</span>";
			}
			if (useOnSupplier === 'Y'){
				html +=" <span class='cf_tag'>"+Loc.g('Fournisseurs')+"</span>";
			}
			if (useOnProspect === 'Y'){
				html +=" <span class='cf_tag'>"+Loc.g('Prospects')+"</span>";
			}
			if (useOnItem === 'Y'){
				html +=" <span class='cf_tag'>"+Loc.g('Produits')+"</span>";
			}
			if (useOnService === 'Y'){
				html +=" <span class='cf_tag'>"+Loc.g('Services')+"</span>";
			}
			html += "</div></li>";
			list.append(html);
			
		} else {
			list.find('#field_'+view.value).remove();
		}

		if (list.find('.oneField').length === 1){
			list.find('.noField').show();
		} else {
			list.find('.noField').hide();
		}

		list.sortable('refresh');
		
	},
	
	removeFieldFromGroup: function(cfid){
		
		var list	= $('#cfg_groupsFields');
		var select	= $('#cfg_customFieldsSelector');
		
		list.find('#field_'+cfid).remove();
		select.find('option[value="'+cfid+'"]').prop("selected", false);;
		select.multipleSelect('refresh');
		
		if (list.find('.oneField').length === 1){
			list.find('.noField').show();
		} else {
			list.find('.noField').hide();
		}
		
		list.sortable('refresh');
		
	}
	
};

window.CustomFieldLinkBuilder = {
	
	editLink : function(linkedid, linkedtype){
		
		var options = {
			dialogClass : "white",
            title   	: Loc.g("Modification des champs personnalisés"),
            buttons    	: [
				{text : Loc.g("Annuler"), click : function(){MyWindow.close();}},
				{text : Loc.g("Enregistrer"), click : function(){$("#cfLinkForm").submit();}}
            ],
            width : MyWindow.medium,
            callback    : function(){
				MyFacture.customForm()
				var formId = "cfLinkForm";
				var options = {
					success:function(data){
						var formIsOk = MyForm.processJson(data, "cfLinkForm");
						if(formIsOk){
							MyWindow.close();
							Utils.reload();
						}
					},
					dataType:"json"
				};

				MyForm.prepare(formId, "customfields&action=recordLinkForm", options, true);
				Qtip.init();
            }
        };
        
        MyWindow.load("customfields", {action:"linkForm", linkedtype:linkedtype, linkedid:linkedid}, options);

	},
	
};

window.CustomFieldForm = {
	massEditForm: function(linkedtype, linkedids, listingname){

		var options = {
			title	: Loc.g("Modification des champs personnalisés sur tous les éléments sélectionnés"),
			width : 500,
			buttons	: [
                {text : Loc.g("Annuler"), click : function(){
                    $(this).dialog("close");
                }},
                {text : Loc.g("Enregistrer"), click : function(btn){
						!$('body').data('massEditCustomFieldFormDisabled') && $("#massEditCustomFieldForm").submit();

						MyForm.toggleDisabledForm({
							btn : $(btn.currentTarget),
							dataToCheckOnBody : 'massEditCustomFieldFormDisabled'
						});
				}}
			],
			callback	: function(){
				CustomFieldForm.prepareEditForm('recordMassLinkForm', 'massEditCustomFieldForm');
			}
		};
		
		var params = {
			action:			"massLinkForm", 
			linkedtype:		linkedtype, 
			linkedids:		linkedids
		};
		
		if(listingname){
			params['listingname'] = listingname;
		}
		
		MyWindow.load("customfields", params, options);

	},

	prepareEditForm: function(action, formid){

		MyFacture.customForm();

		checkNoCustomField = function(){
			var noCustomField = $('#massEditCustomFieldForm > .noCustomField');
			var btnSave = $('.ui-dialog .ui-dialog-buttonset button:last');

			var isNoCustomFieldSelected = $('#customFieldsContainer > div').not('.hidden').length > 0;

			noCustomField.toggleClass('hidden', $('#customFieldsContainer > div').not('.hidden').length > 0).css('display');
		};

		displayAll = function(toDisplay){

			var elementsArray = [];
			var cfcontainer = $('#customFieldsContainer');
			var cfgroupes = cfcontainer.children('[id*="cfgroupe_"]');
			var formgroups = cfgroupes.children('.form-group');
			
			elementsArray.push(cfcontainer.children('.cfTitle'), cfgroupes, formgroups, formgroups.find('input, select'));

			$.each(elementsArray, function(){
				$(this).toggleClass('hidden', !toDisplay);
			});

			checkNoCustomField();
		};

		displayFormGroups = function(cfid, toDisplay){
			var cfformgroup = $('#formgroup'+cfid);
			var fields = cfformgroup.find('.form-input').find('input, select');

			cfformgroup.add(fields).toggleClass('hidden', !toDisplay);
		};

		var multipleselectoptions = {
			placeholder: Loc.g("Choisissez les champs personnalisés à éditer"),
			width: 400,
			selectAll: true,
			position: 'bottom',
			countSelected : false,
			selectAllText: Loc.g('Tout Sélectionner'),
			allSelected: Loc.g('Tous sélectionnés'),
			onCheckAll: function(){
				displayAll(true);
			},
			onUncheckAll: function(){
				displayAll(false);
			},
			onOptgroupClick: function(view){
				if(view.children[0]){
					var firschild = $('#formgroup'+view.children[0].value);
					var cfgroup = firschild.parent();
					var cftitle = cfgroup.prev('.cfTitle');

					cfgroup.add(cftitle).toggleClass('hidden', !view.checked);
										
					$.map(view.children, function(child){
						displayFormGroups(child.value, view.checked);
					});
				}
				checkNoCustomField();
			},
			onClick: function(view) {
				displayFormGroups(view.value, view.checked);

				// HIDE THE TITLE OF THE CF GROUP IF NO FIELDS VISIBLE
				var cfgroup = $('#formgroup'+view.value).parent();
				var cftitle = cfgroup.prev('.cfTitle');

				cfgroup.add(cftitle).toggleClass('hidden', cfgroup.find('.form-group[id*="formgroupCf"]').not('.hidden').length == 0);

				checkNoCustomField();
			}
		};
		
		var selectCFToEdit = $('#massEditCustomFieldForm select#selectCFToEdit').length > 0 ? $('#massEditCustomFieldForm select#selectCFToEdit') : null;
        selectCFToEdit && selectCFToEdit.multipleSelect(multipleselectoptions);
        displayAll(false);

		var options = {
			success: function (data) {
				var formIsOk = MyForm.processJson(data, formid);
				if(data.error){
					var opt = {
						title: Loc.g('Erreur'),
						type: 'error',
						buttons: [
							{
								text: Loc.g("Ok"), 
								click: function () {
									$(this).dialog("close");
								}
							}
						],
					};
					MyWindow.alert(data.error, opt);
					
				} else if(formIsOk) {
					var opt = {
						title: Loc.g('Champs personnalisés modifiés'),
						type: 'confirm',
						buttons: [
							{
								text: Loc.g("Ok"), 
								click: function () {
									$(this).dialog("close");
								}
							}
						],
					};
					MyWindow.alert(Loc.g("Valeur des champs personnalisés modifiées pour les éléments sélectionnées"), opt);
					Utils.reload();
					
				}
				if(data.error || !formIsOk){
					MyForm.toggleDisabledForm({
						btn : $('#popupWindow').next().find('button:last'),
						dataToCheckOnBody : 'massEditCustomFieldFormDisabled',
						toEnabled : true
					});					
				}
			}, 
			dataType: "json"
		};

		Qtip.init();

		MyForm.prepare(formid, "customfields&" + $.param({action: action}), options, true);
		
	}

};

window.CustomFieldTab = {

    loadCustomFieldTab: function(linkedtype, linkedid, editpermission){
        
        $('#content_customfields').html(MyWindow.getLoader());

        var options = {
            action          : "loadCustomFieldTab",
            linkedid        : linkedid,
            linkedtype      : linkedtype,
            editpermission  : editpermission,
        };

        MyFacture.post('customfields', options, function (data) {
            $('#content_customfields').html(data.listing);
        }, 'json');
    }
};